import { STYLE_RADIUS_SIZE } from '../../constants/index'

export default {
  props: ['radius'],
  data () {
    return {
      radiusStyle: { borderRadius: STYLE_RADIUS_SIZE + 'rem' }
    }
  },
  created () {
    if (this.radius) {
      let borderRadius = ''
      for (let i = 0; i < 4; i++) {
        borderRadius += (STYLE_RADIUS_SIZE * ((this.radius & 2 ** i) >> i) + 'rem ')
      }
      this.radiusStyle = {borderRadius: borderRadius}
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/BorderMixin.js